import { Skeleton, Table, TableBody, TableCell, TableRow } from '@repo/shadcn';

type CustomSkeltopProps = {
    count: number;
    type: 'table' | 'card';
};
export const CustomSkelton = ({ count, type }: CustomSkeltopProps) => {
    const generateColumn = (count: number) => {
        if (count > 0 && count < 2) {
            return 'lg:grid-cols-1';
        }
        if (count >= 2 && count < 3) {
            return 'lg:grid-cols-2';
        }
        if (count >= 3 && count < 4) {
            return 'lg:grid-cols-3';
        }
        if (count >= 4 && count < 6) {
            return 'lg:grid-cols-4';
        }
        if (count >= 6 && count <= 8) {
            return 'lg:grid-cols-4';
        }
    };
    if (!isNaN(count) && type == 'card') {
        const numbersArray = Array.from(
            { length: count },
            (_, index) => index + 1,
        );
        const result = numbersArray.map((value) => {
            return value * 2;
        });
        return (
            <div className={`grid gap-4 ${generateColumn(count)}`}>
                {result.map((_, index) => (
                    <div
                        key={index}
                        className="flex w-full items-center space-x-4 rounded-md  bg-white px-4 py-6"
                    >
                        <Skeleton className="h-12 w-12 rounded-full" />
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-[250px]" />
                            <Skeleton className="h-4 w-[200px]" />
                        </div>
                    </div>
                ))}
            </div>
        );
    } else {
        return (
            <Table>
                <TableBody>
                    {Array.from({ length: count }).map((_, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Skeleton className="h-4 w-16" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="h-4 w-24" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="h-4 w-28" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="h-6 w-20 rounded-full" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="h-4 w-8" />
                            </TableCell>
                            <TableCell className="text-right">
                                <Skeleton className="ml-auto h-4 w-16" />
                            </TableCell>
                            <TableCell>
                                <Skeleton className="ml-auto h-8 w-8 rounded-full" />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
};
